"use client"

import React, { useState } from "react"
import { Button, Card, Dropdown } from "antd"

const templates = [
  {
    id: "minimal",
    name: "Minimal",
    description: "Clean, simple design with essential info only",
    preview: "🎯",
    color: "linear-gradient(to right, #60A5FA, #2563EB)",
  },
  {
    id: "luxury",
    name: "Luxury",
    description: "Premium design with elegant styling",
    preview: "💎",
    color: "linear-gradient(to right, #A78BFA, #7C3AED)",
  },
  {
    id: "modern",
    name: "Modern",
    description: "Contemporary design with animations",
    preview: "🚀",
    color: "linear-gradient(to right, #34D399, #059669)",
  },
  {
    id: "classic",
    name: "Classic",
    description: "Traditional layout with clear sections",
    preview: "📋",
    color: "linear-gradient(to right, #FB923C, #EA580C)",
  },
  {
    id: "video",
    name: "Video Focus",
    description: "Large video area with minimal cart info",
    preview: "🎬",
    color: "linear-gradient(to right, #F87171, #DC2626)",
  },
  {
    id: "split",
    name: "Split Screen",
    description: "Equal split between promotions and cart",
    preview: "⚖️",
    color: "linear-gradient(to right, #818CF8, #4F46E5)",
  },
]

export default function TemplateSelector({ currentTemplate, onTemplateChange }) {
  const [isOpen, setIsOpen] = useState(false)

  const menu = (
    <Card
      style={{
        width: 320,
        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(4px)",
        border: "none",
      }}
      styles={{ body: { padding: 16 } }}
    >
      <h3 style={{ fontWeight: "bold", fontSize: 16, marginBottom: 16 }}>Choose Template</h3>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {templates.map((template) => (
          <div
            key={template.id}
            onClick={() => {
              onTemplateChange(template.id)
              setIsOpen(false)
            }}
            style={{
              padding: 12,
              borderRadius: 8,
              cursor: "pointer",
              transition: "all 0.3s",
              background:
                currentTemplate === template.id ? template.color : "#F5F5F5",
              color: currentTemplate === template.id ? "#FFFFFF" : "#000000",
              transform: currentTemplate === template.id ? "scale(1.05)" : "scale(1)",
              boxShadow:
                currentTemplate === template.id
                  ? "0 4px 12px rgba(0,0,0,0.2)"
                  : "none",
            }}
            onMouseEnter={(e) =>
              currentTemplate !== template.id &&
              (e.currentTarget.style.background = "#E5E7EB")
            }
            onMouseLeave={(e) =>
              currentTemplate !== template.id &&
              (e.currentTarget.style.background = "#F5F5F5")
            }
          >
            <div style={{ fontSize: 24, marginBottom: 4 }}>{template.preview}</div>
            <div style={{ fontWeight: 600, fontSize: 14 }}>{template.name}</div>
            <div style={{ fontSize: 12, opacity: 0.75 }}>{template.description}</div>
          </div>
        ))}
      </div>
    </Card>
  )

  return (
    <div style={{ position: "fixed", top: 16, right: 16, zIndex: 50 }}>
      {/* <Dropdown
        overlay={menu}
        trigger={["click"]}
        open={isOpen}
        onOpenChange={setIsOpen}
      >
        <Button
          style={{
            background: "rgba(255, 255, 255, 0.9)",
            color: "#1F2937",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            border: "none",
            backdropFilter: "blur(4px)",
          }}
          size="small"
        >
          🎨 Templates
        </Button>
      </Dropdown> */}
    </div>
  )
}